define([
	"dojo/_base/declare",
	"csi/locale",
	"csi/heading/Expression"
], function(declare, locale, Expression) {

	return declare(Expression, {
		_getValue: function(/*Context*/ctx, /*Heading*/h) {
			var cv = ctx.getNode();
			var key = ctx.view._getContainerKey(cv);
			var view = ctx.view._getViewDefinition(key, cv);
			if (!view) {
				return "";
			}

			if (view.relRoot) {
				return cv.PageSize || locale.resource("PAGE_ALL");
			}

			return 1;
		}
	});
});